// /utils/tokenManager.js
import axios from "axios";

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (token) {
      prom.resolve(token);
    } else {
      prom.reject(error);
    }
  });
  failedQueue = [];
};

const createAxiosInstance = (baseURL) => {
  const instance = axios.create({
    baseURL,
    withCredentials: false,
    headers: {
      "Content-Type": "application/json",
    },
  });

  instance.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("CORE_MODULE_AUTH");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  instance.interceptors.response.use(
    (response) => {
      if (response.status >= 200 && response.status <= 299) {
        return baseURL === `${process.env.REACT_APP_ERP_API_URL}`
          ? response.data
          : response;
      }
      return Promise.reject(
        baseURL === `${process.env.REACT_APP_ERP_API_URL}`
          ? response.data
          : response
      );
    },
    async (error) => {
      const originalRequest = error.config;

      if (error.response?.status === 401 && !originalRequest._retry) {
        if (isRefreshing) {
          try {
            const token = await new Promise((resolve, reject) => {
              failedQueue.push({ resolve, reject });
            });
            originalRequest.headers.Authorization = `Bearer ${token}`;
            return instance(originalRequest);
          } catch (err) {
            return Promise.reject(err);
          }
        }

        originalRequest._retry = true;
        isRefreshing = true;

        try {
          const authData = JSON.parse(localStorage.getItem("AUTH"));
          const { access_token, refresh_token } = authData || {};

          if (!access_token || !refresh_token) {
            logoutUser();
            throw new Error("No token found");
          }

          // Call refresh token API
          const response = await axios.post(
            `${process.env.REACT_APP_ERP_API_URL}/auth/refreshtoken`,
            { access_token, refresh_token }
          );

          const newAccessToken = response.data?.data?.access_token;
          const newRefreshToken = response.data?.data?.refresh_token;

          if (!newAccessToken || !newRefreshToken) {
            logoutUser();
            throw new Error("Invalid token response");
          }

          const user = JSON.parse(localStorage.getItem("AUTH"));
          user.access_token = newAccessToken;
          user.refresh_token = newRefreshToken;
          localStorage.setItem("AUTH", JSON.stringify(user));
          localStorage.setItem("CORE_MODULE_AUTH", newAccessToken);

          processQueue(null, newAccessToken);

          originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
          return instance(originalRequest);
        } catch (err) {
          console.error("Refresh token failed:", err);
          processQueue(err, null);
          logoutUser();
          return Promise.reject(err);
        } finally {
          isRefreshing = false;
        }
      }

      if (error.response) {
        return Promise.reject(error.response.data);
      }

      return Promise.reject(error);
    }
  );

  return instance;
};

const logoutUser = () => {
  console.log("Logged Out");
  localStorage.removeItem("AUTH");
  localStorage.removeItem("CORE_MODULE_AUTH");
  localStorage.removeItem("user");
  localStorage.removeItem("module_info");
  localStorage.removeItem("menu_list");
  // Router.push('/signin');
  localStorage.clear();
  window.location.href = process.env.REACT_APP_ERP_FE;
};

export default createAxiosInstance;
